import { useFormikContext } from 'formik';
import { Button } from 'shared-components';
import { ButtonIntent, ButtonTier } from 'shared-components';
import { FormGroup } from 'shared-components';
// import { Event } from './events.types';
import styles from './event-details.module.css';
import {
  useDeleteCoverMutation,
  useGetCoverQuery,
  useGetEventQuery,
} from './events.api';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { toast } from 'react-toastify';
import { IEvent } from '@topshots/core-models';
import { CardContent } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { Checkbox } from 'shared-components';
import classNames from 'classnames';
import { FormLayout } from 'shared-components';

export const EventDetails = ({ eventId }: { eventId: string }) => {
  const { data: event, isLoading, isFetching } = useGetEventQuery(eventId);

  const [deleteCover] = useDeleteCoverMutation();
  const { getFieldProps, values } = useFormikContext<IEvent>();
  const {
    data,
    isLoading: isLoadingCover,
    isFetching: isFetchingCover,
    refetch: refetchCover,
  } = useGetCoverQuery(event?._id.toString() ?? '');
  const dispatch = useAppDispatch();
  return isFetching || isLoading ? (
    <CardContent>
      <span>...Loading</span>
    </CardContent>
  ) : (
    <CardContent>
      <FormLayout className={styles.details}>
        <FormGroup className={styles.coverImage}>
          <Label htmlFor="cover">Cover</Label>

          {isLoadingCover || isFetchingCover ? (
            <span>loading...</span>
          ) : (
            <>
              <div
                className={classNames(styles.coverImage__cover, {
                  [styles.coverImage__cover_empty]: !data?.url,
                  [styles.coverImage__cover_full]: data?.url,
                })}
                style={{
                  backgroundImage: `url(${data?.url})`,
                }}
              ></div>
              <div className={styles.coverImage__buttons}>
                {data?.url && (
                  <Button
                    onClick={async () => {
                      if (
                        // eslint-disable-next-line no-restricted-globals
                        confirm('Are you sure you want to clear the cover?')
                      ) {
                        await deleteCover(eventId);
                        refetchCover();
                        toast.success('Cover cleared');
                      }
                    }}
                    intent={ButtonIntent.Negative}
                    tier={ButtonTier.Secondary}
                  >
                    Clear
                  </Button>
                )}
                <Button
                  className="w-100"
                  onClick={() => {
                    dispatch(
                      open({
                        title: 'Change cover',
                        contentKey: 'event-cover-upload',
                        contentPayload: {
                          eventId,
                        },
                      })
                    );
                  }}
                  intent={ButtonIntent.Positive}
                  tier={ButtonTier.Secondary}
                >
                  {data?.url ? 'Change' : 'Upload'}
                </Button>
              </div>
            </>
          )}
        </FormGroup>
        <FormGroup
          style={{
            gridArea: 'name',
          }}
        >
          <Label htmlFor="name">Name</Label>
          <Input {...getFieldProps('name')} type="text" id="name" />
        </FormGroup>
        <FormGroup
          style={{
            gridArea: 'date',
          }}
        >
          <Label htmlFor="date">Date</Label>
          <Input {...getFieldProps('date')} type="date" id="date" />
        </FormGroup>
        <FormGroup
          style={{
            gridArea: 'archived',
          }}
        >
          <Checkbox
            label="Is archived?"
            type="checkbox"
            id="isArchived"
            disabled={true}
            defaultChecked={event?.isArchived}
            {...getFieldProps('isArchived')}
          />
        </FormGroup>
        <FormGroup
          style={{
            gridArea: 'hasPassword',
          }}
        >
          <Checkbox
            label="Has password?"
            type="checkbox"
            id="requiresPassword"
            defaultChecked={event?.requiresPassword}
            {...getFieldProps('requiresPassword')}
          />
        </FormGroup>
        {values.requiresPassword && (
          <FormGroup
            style={{
              gridArea: 'password',
            }}
          >
            <Label htmlFor="password">Password</Label>
            <Input
              {...getFieldProps('password')}
              type="password"
              id="password"
            />
          </FormGroup>
        )}
      </FormLayout>
    </CardContent>
  );
};
